export default [
  {
    title: 'Budget',
    icon: 'DollarSignIcon',
    // The group is visible when any child is authorized. Dashboard permission
    // must not hide management/allocation modules granted independently.
    children: [
      {
        title: 'Budget',
        route: 'budget',
        icon: 'CircleIcon',
        action: 'manage',
        resource: 'Budget',
      },
      {
        title: 'Alocação',
        route: 'budget-alocacao',
        icon: 'SlidersIcon',
        action: 'alocar',
        resource: 'BudgetAlocacao',
      },
      {
        title: 'Dashboard',
        route: 'budget-dashboard',
        icon: 'BarChart2Icon',
        action: 'read',
        resource: 'BudgetDashboard',
      },
    ],
  },
];
